<template>
  <v-container>
    <v-card
      color="oug"
      class="pa-1 mx-auto text-center justify-center"
      max-width="600"
      elevation="24"
    >
      <v-card-title class="text-h6 white--text">My Certificates</v-card-title>
      <v-card-subtitle class="white--text" align="start">
        Here is a list of your certificates for your various accreditations. If
        you click on one below, it will open the certificate in a new tab on
        your device.
      </v-card-subtitle>
          <div>
      <v-dialog
      v-model="loadingDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="oug"
        dark
      >
        <v-card-text>
          Loading Certificates. Please Stand By
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
      <v-list dense>
        <v-list-item v-for="(item, i) in userAccreds" :key="i">
          <v-list-item-content>
            <v-list-item-title align="start">{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle align="start"
              >Expiry: {{ item.end_date }}</v-list-item-subtitle
            >
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              icon
              @click="
                openDocument(
                  `https://siteextensions.ownurgoal.net.au/displayCert/${currentUser.Firstname}%20${currentUser.Surname},${item.end_date},${item.name},BQ_Coaching.pdf`
                )
              "
            >
              <v-icon large color="oug">mdi-download</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
    <div class="mt-2" v-if="this.userAccreds == 0">
      <v-container>
        <p align="center">
          You have no current certificates. To work towards an accreditation
          certificate, you can do so from the 'Courses/Online Components'
          section of the Coaches App. If you believe you should have a
          certificate but nothing is appearing, contact Luke McGuire in the
          People section of the App
        </p>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import { authComputed, getUser } from "../veux/helpers";
import axios from "axios";

export default {
  data() {
    return {
      loadingDialog: false,
      userAccreds: [],
    };
  },
  created() {
    this.loadAccreds();
  },
  methods: {
    openDocument(url) {
      let file = url;
      window.open(file, "_system");
    },

    loadAccreds() {
      //   this.today = dayjs.formatDate(new Date(), "DD-MM-YYYY");
      // Load Accreditations by type from the Coaches App
      const payload = { Contact_id: this.currentUser.Contact_id, Team_id: 423 };
      this.loadingDialog = true;
      const baseURL = "https://server.ownurgoal.net.au/gen/GetAccreds";
      axios.post(baseURL, payload).then((response) => {
        this.allAccreds = response.data.result;
        // console.log("bookings response", this.allBookings);
        this.allAccreds.forEach((element) => {
          // console.log("element", element)
          this.userAccreds.push({
            name: element.Accred_Name,
            start_date: element.Start_Date,
            end_date: element.End_date,
          });
        });
        this.loadingDialog = false;
      });
    },
  },
  computed: {
    ...authComputed,
    ...getUser,
  },
};
</script>

<style>
</style>